import { simpleObjectCopy } from './miscellanea';
import Errors from './Errors';

export default class Form<T extends object> {
  public data: T;
  public errors: Errors;
  private readonly defData: T;

  constructor(data: T, defaultData: T | null = null) {
    if (defaultData) {
      this.defData = simpleObjectCopy(defaultData);
    } else {
      this.defData = simpleObjectCopy(data);
    }

    this.data = data;

    this.errors = new Errors(Object.keys(data));
  }

  clear() {
    this.errors.clear();
    this.data = simpleObjectCopy(this.defData);
  }
}
